export default __webpack_public_path__ + "static/media/IMG_094.945c9eeb.jpg";